import { IconButton, Menu, MenuItem } from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import { ReactNode, useState } from 'react'

export interface MenuOption {
    title: string
    icon: ReactNode
    action: (item: string | undefined) => void
}

interface Props {
    options: MenuOption[]
    selectedItem?: string
}

const MenuDropdown = ({ options, selectedItem }: Props) => {
    const [anchorEl, setAnchorEl] = useState(null)
    const open = Boolean(anchorEl)

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <div>
            <IconButton onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    style: {
                        padding: '0px',
                    },
                }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                sx={{
                    '& .MuiPaper-root': {
                        transform: 'translateY(40px) !important',
                    },
                }}
            >
                {options.map((option) => (
                    <MenuItem
                        key={option.title}
                        onClick={() => {
                            handleClose()
                            option.action(selectedItem)
                        }}
                    >
                        <div className="flex items-center">
                            {option.icon}
                            {option.title}
                        </div>
                    </MenuItem>
                ))}
            </Menu>
        </div>
    )
}

export default MenuDropdown
